import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Button,
  Box
} from '@mui/material';

const ProductCard = ({ product, addToCart, quantityInCart }) => {

  const stock = product.stock ?? Math.floor(Math.random() * 8) + 1;

  return (
    <Card
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        borderRadius: '20px',
        backdropFilter: 'blur(12px)',
        background: 'rgba(255,255,255,0.05)',
        border: '1px solid rgba(255,255,255,0.1)',
        transition: 'all 0.3s ease',
        overflow: 'hidden',
        '&:hover': {
          transform: 'translateY(-8px)',
          boxShadow: '0 0 25px rgba(255,110,0,0.4)'
        }
      }}
    >

      <CardContent sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>

        {/* 🔥 STOCK (AHORA NO ROMPE EL TÍTULO) */}
        <Box sx={{ mb: 1, display: 'flex', justifyContent: 'flex-end' }}>
          <Box
            sx={{
              background: 'linear-gradient(90deg, #ff6e00, #ffae00)',
              color: '#000',
              px: 1.5,
              py: 0.3,
              borderRadius: '10px',
              fontSize: '0.7rem',
              fontWeight: 'bold'
            }}
          >
            ⚡ {stock} disponibles
          </Box>
        </Box>

        {/* TITULO */}
        <Typography variant="h6" sx={{ color: '#fff', fontWeight: 'bold', textAlign: 'center' }}>
          {product.name}
        </Typography>

        <Typography
          variant="body2"
          sx={{ color: 'rgba(255,255,255,0.7)', mt: 1, textAlign: 'center' }}
        >
          {product.description}
        </Typography>

        {/* IMAGEN */}
        <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', py: 3 }}>
          <Box
            component="img"
            src={product.image}
            alt={product.name}
            sx={{
              maxHeight: '180px',
              transition: 'transform 0.3s ease',
              '&:hover': { transform: 'scale(1.05)' }
            }}
          />
        </Box>

        {/* PRECIO */}
        <Typography variant="h6" sx={{ color: '#ffae00', fontWeight: 'bold', textAlign: 'center' }}>
          ${product.price}
        </Typography>

        {/* BOTÓN */}
        <Button
          variant="contained"
          onClick={() => addToCart(product)}
          sx={{
            mt: 1,
            background: 'linear-gradient(90deg, #ff6e00, #ffae00)',
            fontWeight: 'bold',
            borderRadius: '12px',
            textTransform: 'none'
          }}
        >
          🚀 Agregar al carrito
        </Button>

        {quantityInCart > 0 && (
          <Typography variant="caption" sx={{ mt: 1, textAlign: 'center', color: '#fff' }}>
            🔥 En carrito: {quantityInCart}
          </Typography>
        )}

      </CardContent>
    </Card>
  );
};

export default ProductCard;